export default __webpack_public_path__ + "static/media/recycle.ecb78eed.svg";